import { MapPin, ExternalLink } from 'lucide-react';

// Clickable Location Component - opens Google Maps
export const LocationLink = ({ location, locationUrl, className = "" }) => {
  if (!location) return null;

  // Use provided URL if available, otherwise generate search URL
  let mapsUrl;
  if (locationUrl && (locationUrl.startsWith('http://') || locationUrl.startsWith('https://'))) {
    mapsUrl = locationUrl;
  } else {
    // Fallback: Clean and format the location for Google Maps search
    const cleanLocation = location.trim().replace(/\s+/g, ' ');
    mapsUrl = `https://www.google.com/maps/search/${encodeURIComponent(cleanLocation)}`;
  }

  return (
    <a
      href={mapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 hover:underline cursor-pointer ${className}`}
      onClick={(e) => e.stopPropagation()}
      title="Open in Google Maps"
    >
      <MapPin className="h-3 w-3" />
      <span>{location}</span>
      <ExternalLink className="h-3 w-3 opacity-50" />
    </a>
  );
};

export default LocationLink;
